import {useMaterialStorage, MaterialStorage, useSiloFillLevels} from '@domain/material-storage'
import {UseQueryOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'

type Params = {
  plantId: string
  snapshotDateTime: string
  options?: Omit<UseQueryOptions<MaterialStorage[], AxiosError>, 'queryKey'>
}

export const useMaterialStorageWithFallback = ({plantId, snapshotDateTime, options}: Params) => {
  const materialStorageQuery = useMaterialStorage({plantId, snapshotDateTime, options})

  const siloFillLevelsQuery = useSiloFillLevels({
    plantId,
    snapshotDateTime,
    options: {
      ...options,
      enabled:
        (options?.enabled ?? true) &&
        materialStorageQuery.isSuccess &&
        materialStorageQuery.data?.length === 0
    }
  })

  const hasMaterialStorageData =
    materialStorageQuery.isSuccess && (materialStorageQuery.data?.length ?? 0) > 0

  return {
    data: hasMaterialStorageData ? materialStorageQuery.data : siloFillLevelsQuery.data,
    isLoading: materialStorageQuery.isLoading || siloFillLevelsQuery.isLoading,
    error: hasMaterialStorageData ? materialStorageQuery.error : siloFillLevelsQuery.error
  }
}
